import React, { useRef, useState, MouseEvent, ReactNode } from 'react';

interface HoverButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  glowColor?: string;
  backgroundColor?: string;
  textColor?: string;
  hoverTextColor?: string;
}

const HoverButton: React.FC<HoverButtonProps> = ({
  children,
  onClick,
  className = '',
  disabled = false,
  glowColor = '#e57605',
  backgroundColor = '#18181b',
  textColor = '#ffffff',
  hoverTextColor = '#f29b2a',
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [glowPosition, setGlowPosition] = useState({ x: 50, y: 50 });
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseMove = (e: MouseEvent<HTMLButtonElement>) => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setGlowPosition({ x: e.clientX - rect.left, y: e.clientY - rect.top });
    }
  };

  return (
    <button
      ref={buttonRef}
      onClick={onClick}
      disabled={disabled}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`relative inline-flex items-center justify-center gap-2 px-6 py-3 border-none cursor-pointer overflow-hidden transition-colors duration-300 text-sm font-semibold rounded-lg ${disabled ? 'opacity-40 cursor-not-allowed' : ''} ${className}`}
      style={{ backgroundColor, color: isHovered ? hoverTextColor : textColor }}
    >
      <div
        className="absolute rounded-full pointer-events-none transition-transform duration-300 ease-out"
        style={{
          left: `${glowPosition.x}px`,
          top: `${glowPosition.y}px`,
          width: '200px',
          height: '200px',
          transform: `translate(-50%, -50%) scale(${isHovered ? 1.2 : 0})`,
          background: `radial-gradient(circle, ${glowColor} 10%, transparent 70%)`,
          opacity: 0.5,
          zIndex: 0,
        }}
      />
      <span className="relative z-10 flex items-center gap-2">{children}</span>
    </button>
  );
};

export { HoverButton };
